// Imagens das baterias (caminho: ../../Assets/nome-da-imagem.png)
import motoKf from "../Assets/moto-kf.png";
import caminhaoKf from "../Assets/caminhao-kf.png";
import caminhaoJupiter from "../Assets/caminhao-jupiter.png";
import caminhaoMarte from "../Assets/caminhao-marte.png";
import caminhaoZetta from "../Assets/caminhao-zetta.png";
import caminhaoMoura from "../Assets/caminhao-moura.png";
import motoHaizer from "../Assets/moto-haizer.png";
import motoJupiter from "../Assets/moto-jupiter.png";
import motoMarte from "../Assets/moto-marte.png";
import motoMoura from "../Assets/moto-moura.png";
import carroMoura from "../Assets/carro-moura.png";
import carroZetta from "../Assets/carro-zetta.png";
import carroSolex from "../Assets/carro-solex.png";
import carroHeliar from "../Assets/carro-heliar.png";
import carroLumix from "../Assets/carro-lumix.png";
import carroJupiter from "../Assets/carro-jupiter.png";
import carroKf from "../Assets/carro-kf.png";

import { RiWhatsappFill } from "react-icons/ri";

import React from "react";
import "./sections.css";

/* Regras de ETA */
function etaByDistanceKM(km) {
  return km <= 10 ? "30 minutos" : "40 minutos";
}
function hasCoords(loc) {
  return loc && Number.isFinite(loc.lat) && Number.isFinite(loc.lng);
}
function safeWhere(loc) {
  if (!loc) return null;
  if (loc.endereco) return loc.endereco;
  if (hasCoords(loc)) return `${loc.lat.toFixed(5)}, ${loc.lng.toFixed(5)}`;
  return null;
}
function safeEta(loc) {
  if (!loc) return "40 minutos";
  if (loc.eta) return loc.eta;
  if (Number.isFinite(loc.km)) return etaByDistanceKM(loc.km);
  return "40 minutos";
}

/* Ícones SVG (sem libs) */
const IconZap = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden {...props}>
    <path fill="currentColor" d="M13 2 3 14h7l-1 8 11-14h-7V2z" />
  </svg>
);
const IconClock = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden {...props}>
    <path
      fill="currentColor"
      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm.75 10.1 3.9 2.25-.75 1.3L11 12V6.5h1.5Z"
    />
  </svg>
);
const IconShield = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden {...props}>
    <path
      fill="currentColor"
      d="M12 2 4 5v6c0 5 3.4 8.7 8 11 4.6-2.3 8-6 8-11V5l-8-3Zm0 18c-3.5-2-6-5-6-9V6.6l6-2.2 6 2.2V11c0 4-2.5 7-6 9Z"
    />
  </svg>
);
const IconPhone = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden {...props}>
    <path
      fill="currentColor"
      d="M6.6 10.8c1.5 2.9 3.7 5.1 6.6 6.6l2.2-2.2c.3-.3.8-.4 1.1-.2 1 .4 2 .6 3.1.6.6 0 1 .4 1 .9V20c0 .6-.4 1-1 1C10.8 21 3 13.2 3 3.4 3 2.8 3.4 2 4 2h3.5c.5 0 .9.4.9 1 0 1.1.2 2.1.6 3.1.1.4 0 .8-.2 1.1l-2.2 2.2Z"
    />
  </svg>
);

// Mapa de imagens por categoria/marca
const IMG = {
  Carros: {
    Moura: carroMoura,
    Heliar: carroHeliar,
    Zetta: carroZetta,
    Jupiter: carroJupiter,
    KF: carroKf,
    Lumix: carroLumix,
  },
  Motos: {
    Moura: motoMoura,
    Haizer: motoHaizer,
    Jupiter: motoJupiter,
    Marte: motoMarte,
    KF: motoKf,
  },
  Pesada: {
    Jupiter: caminhaoJupiter,
    KF: caminhaoKf,
    Moura: caminhaoMoura,
    Marte: caminhaoMarte,
    Zetta: caminhaoZetta,
  },
};

/* ===== BatteryCard — inclui localização/ETA no Whats ===== */

// helper para escolher a imagem a partir de categoria/marca
function getBatteryImg(battery) {
  const byCat = IMG[battery.categoria] || {};
  return (
    byCat[battery.marca] ||
    (battery.categoria === "Carros"
      ? carroSolex
      : battery.categoria === "Motos"
      ? motoKf
      : caminhaoKf)
  );
}

function BatteryCard({ battery, loc }) {
  const where = safeWhere(loc);

  const texto =
    `Olá! Tenho interesse na bateria ${battery.marca} ${battery.modelo} (${battery.amperagem}).` +
    (where ? `\n\nLocalização: ${where}` : "");

  const whatsappLink =
    "https://wa.me/5516982172448?text=" + encodeURIComponent(texto);

  const imgSrc = getBatteryImg(battery);
  const alt = `Bateria ${battery.marca} ${battery.modelo} ${battery.amperagem}`;

  return (
    <div
      className={
        "group gradient-card rounded-2xl border transition-all hover:scale-[1.02] " +
        (battery.destaque
          ? "border-accent shadow-glow-accent"
          : "border-outline hover:border-accent/60")
      }
    >
      {battery.destaque && (
        <div className="abs-top-right">
          <span className="badge badge--accent glow-pulse">DESTAQUE</span>
        </div>
      )}

      <div className="p-6 space-y-4">
        {/* Cabeçalho */}
        <div className="space-y-2">
          <div className="row-between gap-2">
            <div>
              <h3 className="brand-24">{battery.marca}</h3>
              <p className="muted-12 fw-700">{battery.modelo}</p>
            </div>
            <div className="chip-amp">
              <IconZap className="i i-primary" />
              <span className="fw-900">{battery.amperagem}</span>
            </div>
          </div>
          <p className="muted-14 line-2">{battery.descricao}</p>
        </div>

        {/* Imagem da bateria */}
        <div className="card__media">
          <img src={imgSrc} alt={alt} className="battery-img" loading="lazy" />
        </div>

        {/* Specs */}
        <div className="grid-2 gap-3">
          <div className="spec">
            <IconZap className="i i-accent" />
            <div className="col">
              <span className="label">Voltagem</span>
              <span className="val">{battery.voltagem}</span>
            </div>
          </div>
          <div className="spec">
            <IconShield className="i i-success" />
            <div className="col">
              <span className="label">Garantia</span>
              <span className="val">{battery.garantia}</span>
            </div>
          </div>
        </div>

        {/* Rodapé */}
        <div className="pt-4 border-top">
          <div className="row-between mb-3">
            {/* <div>
              <p className="muted-12">A partir de:</p>
              <p className="price-28">R$ {battery.preco}</p>
            </div> */}
          </div>

          <a
            href={whatsappLink}
            target="_blank"
            rel="noreferrer"
            className="btn btn--whats w-100"
          >
            <IconPhone className="i" />
            Solicitar Agora
          </a>
        </div>
      </div>

      <div className="hover-overlay" aria-hidden />
    </div>
  );
}

/* ====== CATÁLOGO ====== */
const ALL_PRODUCTS = [
  // (… mesma lista que você já tinha …)
  {
    id: "1",
    marca: "Moura",
    modelo: "60Ah",
    categoria: "Carros",
    amperagem: "60Ah",
    voltagem: "12V",
    garantia: "Consulte Item",
    preco: 450,
    descricao: "Bateria automotiva Moura de alta qualidade e durabilidade",
    destaque: true,
  },
  {
    id: "2",
    marca: "Heliar",
    modelo: "",
    categoria: "Carros",
    amperagem: "60Ah",
    voltagem: "12V",
    garantia: "Consulte Item",
    preco: 480,
    descricao: "Bateria Heliar com tecnologia de ponta para maior performance",
    destaque: true,
  },
  {
    id: "3",
    marca: "Zetta",
    modelo: "",
    categoria: "Carros",
    amperagem: "60Ah",
    voltagem: "12V",
    garantia: "Consulte Item",
    preco: 420,
    descricao: "Excelente custo-benefício para seu veículo",
    destaque: false,
  },

  {
    id: "5",
    marca: "Jupiter",
    modelo: "",
    categoria: "Carros",
    amperagem: "60Ah",
    voltagem: "12V",
    garantia: "Consulte Item",
    preco: 520,
    descricao: "Alta potência para veículos que exigem mais energia",
    destaque: false,
  },

  {
    id: "4",
    marca: "KF",
    modelo: "",
    categoria: "Carros",
    amperagem: "60Ah",
    voltagem: "12V",
    garantia: "Consulte Item",
    preco: 410,
    descricao: "Bateria confiável para uso diário",
    destaque: false,
  },

  {
    id: "5",
    marca: "Lumix",
    modelo: "",
    categoria: "Carros",
    amperagem: "60Ah",
    voltagem: "12V",
    garantia: "Consulte Item",
    preco: 520,
    descricao: "Alta potência para veículos que exigem mais energia",
    destaque: false,
  },

  {
    text: "Baterias para Motos a partir de R$ 150,00",
  },
  {
    id: "6",
    marca: "Moura",
    modelo: "MAS-D",
    categoria: "Motos",
    amperagem: "5Ah",
    voltagem: "12V",
    garantia: "6 meses",
    preco: 180,
    descricao: "Bateria compacta e potente para motos",
    destaque: true,
  },

  {
    id: "9",
    marca: "KF",
    modelo: "KF5M",
    categoria: "Motos",
    amperagem: "6Ah",
    voltagem: "12V",
    garantia: "6 meses",
    preco: 170,
    descricao: "Bateria econômica para uso diário",
    destaque: false,
  },
  {
    id: "10",
    marca: "Haizer",
    modelo: "HZ8",
    categoria: "Motos",
    amperagem: "5Ah",
    voltagem: "12V",
    garantia: "12 meses",
    preco: 240,
    descricao: "Alta capacidade para motos esportivas",
    destaque: false,
  },

  {
    text: "Linha Pesada a partir de R$ 490,00",
  },
  {
    id: "11",
    marca: "Moura",
    modelo: "150Ah",
    categoria: "Pesada",
    amperagem: "150Ah",
    voltagem: "12V",
    garantia: "15 meses",
    preco: 1200,
    descricao: "Bateria de alta capacidade para veículos pesados",
    destaque: true,
  },
  {
    id: "12",
    marca: "KF",
    modelo: "KF180HD",
    categoria: "Pesada",
    amperagem: "150Ah",
    voltagem: "12V",
    garantia: "12 meses",
    preco: 1350,
    descricao: "Máxima potência para trabalho pesado",
    destaque: true,
  },
  {
    id: "13",
    marca: "Jupiter",
    modelo: "JP170HD",
    categoria: "Pesada",
    amperagem: "150Ah",
    voltagem: "12V",
    garantia: "12 meses",
    preco: 1280,
    descricao: "Resistência e durabilidade excepcionais",
    destaque: false,
  },
];

export default function Sections() {
  // estado de filtro (lido da URL ao carregar)
  const [categoria, setCategoria] = React.useState(
    () => new URLSearchParams(window.location.search).get("cat") || "todas"
  );
  const [produtos, setProdutos] = React.useState(() =>
    filtra(ALL_PRODUCTS, categoria)
  );

  // localização compartilhada (para montar os links de Whats)
  const [loc, setLoc] = React.useState(() => {
    try {
      const saved = sessionStorage.getItem("localizacaoAtual");
      return saved ? JSON.parse(saved) : window.localizacaoAtual || null;
    } catch {
      return window.localizacaoAtual || null;
    }
  });

  // escuta evento vindo do Navigation e aplica filtro
  React.useEffect(() => {
    const onCat = (e) => {
      const c = e.detail || "todas";
      setCategoria(c);
      setProdutos(filtra(ALL_PRODUCTS, c));
    };
    window.addEventListener("catalog:category", onCat);
    return () => window.removeEventListener("catalog:category", onCat);
  }, []);

  // escuta atualizações de localização
  React.useEffect(() => {
    const onLoc = (e) => setLoc(e.detail || null);
    window.addEventListener("location:update", onLoc);
    return () => window.removeEventListener("location:update", onLoc);
  }, []);

  // util: aplica regra de filtro
  function filtra(lista, cat) {
    if (cat === "todas") return lista;
    if (cat === "automotivas")
      return lista.filter((p) => p.categoria === "Carros");
    if (cat === "motos") return lista.filter((p) => p.categoria === "Motos");
    if (cat === "pesada") return lista.filter((p) => p.categoria === "Pesada");
    return lista;
  }

  // Link do CTA final com localização (quando houver) — seguro
  const whereCTA = safeWhere(loc);
  const etaCTA = safeEta(loc);
  const whatsCTA =
    "https://wa.me/5516982172448?text=" +
    encodeURIComponent(
      "Olá! Quero uma bateria com entrega e instalação." +
        (whereCTA ? `\n\nLocalização: ${whereCTA}` : "")
    );

  return (
    <main className="page-dark">
      {/* Produtos */}
      <div className="cta-line-section" />
      <section id="baterias" className="sec container">
        <div className="sec__head">
          <span className="pill">⭐ Produtos em Destaque</span>
          <h2 className="sec__title">
            Nossas <span className="accent">Melhores</span> Baterias
          </h2>
        </div>

        <div className="cards">
          {produtos.map((b) => (
            <BatteryCard key={b.id} battery={b} loc={loc} />
          ))}
        </div>
      </section>

      {/* === Por que escolher (MVP) === */}
      <section className="sec sec--dark">
        <div className="container">
          <div className="why__head">
            <h2 className="why__title">
              Por que escolher <span className="accent">Baterias Agora?</span>
            </h2>
            <p className="why__subtitle">
              Oferecemos o melhor serviço de entrega e instalação de baterias da
              região
            </p>
          </div>

          <div className="features-grid">
            <Feature
              variant="clock"
              title="Entrega em 40 min"
              text="Receba e instale sua bateria nova em até 40 minutos. Rapidez garantida!"
              icon={<IconClock className="i" />}
            />
            <Feature
              variant="shield"
              title="Garantia Estendida"
              text="Todas as baterias com garantia de até 24 meses contra defeitos de fabricação."
              icon={<IconShield className="i" />}
            />
            <Feature
              variant="zap"
              title="Instalação Grátis"
              text="Instalação profissional incluída. Não se preocupe com nada!"
              icon={<IconZap className="i" />}
            />
            <Feature
              variant="truck"
              title="Frete Grátis"
              text="Entregamos sem custo adicional em toda a região metropolitana."
              icon={<IconPhone className="i" />}
            />

            {/* NOVO: Card de avaliação 5 estrelas */}
            <Feature
              variant="stars"
              title="Somos 5 estrelas"
              text="Atendimento ágil, instalação impecável e suporte pós-venda."
              icon={
                <div className="stars-5" aria-hidden>
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} viewBox="0 0 24 24" width="18" height="18">
                      <path
                        fill="currentColor"
                        d="M12 2.5 14.9 9l7.1.6-5.4 4.6 1.7 6.9L12 17.7 5.7 21.1l1.7-6.9L2 9.6l7.1-.6L12 2.5z"
                      />
                    </svg>
                  ))}
                </div>
              }
            />
          </div>
        </div>
      </section>

      {/* === CTA Final (MVP) === */}
      <section className="sec container sec-cta" id="contato">
        <div className="cta-card cta-card--mvp">
          <div className="cta-icon-tile">
            <span className="cta-icon-zap">⚡</span>
          </div>

          <h3 className="cta-title">
            Precisa de uma bateria <span className="accent">agora?</span>
          </h3>

          <p className="cta-subtitle">
            Entre em contato e receba sua bateria nova com instalação
            profissional em até 40 minutos! <br />
            <br />
            ENTREGAMOS EM TODA REGIÃO, CONSULTE FRETE.
          </p>

          <div className="cta-actions cta-actions--mvp">
            <a
              className="btn btn--green btn-lg"
              href={whatsCTA}
              target="_blank"
              rel="noreferrer"
            >
              <IconPhone className="icone-phone" />
              Solicitar Agora
            </a>
          </div>
        </div>
      </section>
      <br />

      <section className="section-footer">
        <div className="footer-bottom">
          <p className="footer-copy">
            <strong>
              © 2025 Baterias Agora - Todos os direitos reservados.
            </strong>
          </p>
          <div className="footer-dev">
            <a
              className="footer-dev__link"
              href="https://wa.me/5516982172448?text=Ol%C3%A1%20seja%20bem-vindo%20a%20WebSites%2C%20Usando%20a%20Tecnologia%20a%20seu%20favor!%20Gostaria%20de%20agendar%20uma%20reuni%C3%A3o%2C%20hor%C3%A1rio%20dispon%C3%ADvel%3F"
              target="_blank"
              rel="noreferrer"
              aria-label="Falar no WhatsApp com LD WebSites"
            >
              <RiWhatsappFill className="whats-icon" aria-hidden="true" />
              <span className="partner-text">
                Desenvolvido por: LD Web Sites e Tráfego Pago
              </span>
            </a>
          </div>
        </div>
        <br />
      </section>
    </main>
  );
}

// Substitua o Feature por este (aceita "variant" p/ cores)
function Feature({ icon, title, text, variant = "clock" }) {
  return (
    <div className="feature-card">
      <div
        className={`feature__icon ${"feature__icon--" + variant}`}
        aria-hidden
      >
        {icon}
      </div>
      <h4 className="feature__title">{title}</h4>
      <p className="feature__text">{text}</p>
    </div>
  );
}
